import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

export default function CopiaAtto(
    {
        setNominativo,
        setNaturaAtto,
        setNumeroRepertorio,
        setDataDiStipula,
        setNomeCognomeSoggettiAtto
    }) {
    return (
		<>
            <MDBRow>
                <MDBCol>
                    <div className="field">
                        <label className='customLab' >Nominativo</label>
                        <input type="text" placeholder="Nomitativo" name="nomitativo" id="nomitativo" onChange={e => setNominativo(e.target.value)} />
                    </div>
                </MDBCol>
                <MDBCol>
                    <div className="field">
                        <label className='customLab' >Data di stipula</label>
                        <input type="date" name="date" id="date" onChange={e => setDataDiStipula(e.target.value)} />
                    </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                    <div className="field">
                        <label className='customLab' >Natura dell'Atto</label>
                        <input type="text" placeholder="Tipologia atto" name="natura_atto" id="natura_atto" onChange={e => setNaturaAtto(e.target.value)} />
                    </div>
                </MDBCol>
                <MDBCol>
                    <div className="field">
                        <label className='customLab' >Numero di repertorio</label>
                        <input type="number" placeholder="1234" name="numero_repertorio" id="numero_repertorio" onChange={e => setNumeroRepertorio(e.target.value)} />
                    </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                    <div className="field">
                        <label className='customLab' >Nome o Cognome di uno o più soggetti dell'atto</label>
                        <textarea className="message-field" type="textarea" placeholder="Mario Rossi ..." name="soggettiAtto" id="soggettiAtto" onChange={e => setNomeCognomeSoggettiAtto(e.target.value)} />
                    </div>
                </MDBCol>
            </MDBRow>

            </>
	);
}